import { LayoutDashboard, Package, Truck, UserRound } from 'lucide-react';
import Home from './pages/Home';
import Products from './pages/Products';
import Orders from './pages/Orders';
import Account from './pages/Account';

/**
 * Vendor portal route manifest. { path, Element, label, short?, icon, nav, foot }
 * Every route needs an approved vendor session (VendorApp gates it).
 */
export const vendorRoutes = [
  { path: '/', Element: Home, label: 'Overview', short: 'Home', icon: LayoutDashboard, nav: true, foot: true },
  { path: '/products', Element: Products, label: 'My products', short: 'Products', icon: Package, nav: true, foot: true },
  { path: '/orders', Element: Orders, label: 'Orders to ship', short: 'Orders', icon: Truck, nav: true, foot: true },
  { path: '/account', Element: Account, label: 'Account', icon: UserRound, nav: true, foot: true },
];
